import { FC, MouseEvent } from 'react'
import classnames from 'classnames'
import { noop } from 'lodash-es'
import CheckBox from './forms/CheckBox'
import Label from './forms/label'
import Button from './Button'

type SwitchProps = {
  checkedValue?: string | number | boolean
  uncheckedValue?: string | number | boolean
  checkedLabel?: string
  uncheckedLabel?: string
  value: string | number | boolean
  onChange: (newValue: string | number | boolean) => void
  className?: string
}

type CheckboxChangeEvent = {
  checked: boolean
}

const Switch: FC<SwitchProps> = ({
  checkedValue = 1,
  uncheckedValue = 0,
  checkedLabel = 'On',
  uncheckedLabel = 'Off',
  value = 0,
  onChange = noop,
  className = 'labelled-switch',
}) => {
  const handleChange = (change: CheckboxChangeEvent) => {
    const { checked } = change
    const newValue = checked ? checkedValue : uncheckedValue
    onChange(newValue)
  }

  const dispatchChange = (value: string | number | boolean) => {
    onChange(value)
  }

  const handleCheck = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
    dispatchChange(checkedValue)
  }

  const handleUncheck = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
    dispatchChange(uncheckedValue)
  }

  const checked = value === checkedValue
  const leftClassName = classnames('button-reset', 'labelled-switch__label', {
    'labelled-switch__label--current': !checked,
  })
  const rightClassName = classnames('button-reset', 'labelled-switch__label', {
    'labelled-switch__label--current': checked,
  })

  return (
    <span className={className}>
      <Button className={leftClassName} data-testid="qa-left-label" onClick={handleUncheck}>
        {uncheckedLabel}
      </Button>
      <Label className="switch qa-switch">
        <CheckBox checked={checked} onChange={handleChange} />
        <span className="switch__handle"></span>
      </Label>
      <Button className={rightClassName} onClick={handleCheck} data-testid="qa-right-label">
        {checkedLabel}
      </Button>
    </span>
  )
}

export default Switch
